import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import getEnvLang from './getEnvLang'
import zhCN from './zh-CN'
import enUS from './en-US'
import zhHK from './zh-HK';
import jaJP from './ja-JP';
// eslint-disable-next-line
export const support_langs = ['zh-CN', 'en-US', 'zh-HK', 'ja-JP'];
Vue.use(VueI18n);

const defaultLang = getEnvLang(support_langs);

const i18n: any = new VueI18n({
  locale: defaultLang,
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'zh-HK': zhHK,
    'ja-JP': jaJP
  }
});

export default i18n;
